import service from "Utility/Service";
// import React from "react";
import { useMutation, useQuery, useQueryClient, QueryKey } from "react-query";
import { TimestampToDate } from "../../Utility/Fetch";
import { AxiosRequestConfig } from "axios";
import { repository } from "Utility/Types/upgrade_repository";

const getListByCid = async (level: string, stateCid: string, loginCid: string) => {
  let body: any = { list_file: {} };

  if (level === "super_super" && stateCid !== "") {
    body.list_file.cid = stateCid;
  } else {
    body.list_file.cid = loginCid;
  }

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/repository",
    data: body,
  };

  const { data }: { data: repository } = await service(config);
  return data.response.repository;
};
// 自訂義Hook，用於獲取設備升級儲存庫的列表。
// 依照用戶級別是否決定啟動此 Hook ，如果用戶級別是 get 則不使用查詢資料
export const useRepositoryList = (level: string, stateCid: string, loginCid: string) => {
  return useQuery(["repositoryList", stateCid], () => getListByCid(level, stateCid, loginCid), {
    enabled: level !== "get",
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const downloadFilebyName = ({ cid, name, type }: any) => {
  // const { cid, name, type } = props.values;

  const body = { download_file: { cid, name, type } };

  const config: AxiosRequestConfig = {
    method: "post",
    responseType: "blob",
    url: "/repository",
    data: body,
  };

  return service(config);
};

// 自訂義Hook，用於下載設備升級儲存庫中的資料 *沒有啟用選項，屬於自動請求狀態*
export const useRepositoryDownload = () => {
  return useMutation((props: any) => downloadFilebyName(props));
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getActionByCid = async (level: any, stateCid: any, loginCid: any) => {
  let body: any = { get: { bck_rst_upg_list: { list: {} } } };

  if (level === "super_super" && stateCid !== "") {
    body.get.bck_rst_upg_list.list.cid = stateCid;
  } else if (level !== "super_super") {
    body.get.bck_rst_upg_list.list.cid = loginCid;
  }

  const config: AxiosRequestConfig = {
    method: "post",
    headers: { "Content-Type": "application/json" },
    url: "/cmd",
    data: body,
  };

  const { data } = await service(config);

  return data;
};

// 自訂義 Hook ，用於獲得設備升級操作的列表 Querykey 為 actionList
export const useActionList = (level: string, stateCid: string, loginCid: string) => {
  return useQuery(["actionList", stateCid], () => getActionByCid(level, stateCid, loginCid));
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


const deleteActionById = (param: any) => {
  const { stateCid, id } = param;

  let body: any = { set: { bck_rst_upg_list: { delete: { id: id } } } };

  if (id === "ClearAll") {
    body.set.bck_rst_upg_list.delete = { cid: stateCid };
  }

  const config: AxiosRequestConfig = {
    method: "post",
    headers: { "Content-Type": "application/json" },
    url: "/cmd",
    data: body,
  };

  return service(config);
};
// 自訂義Hook ，用於刪除設備升級操作，依據stateCid、id 來刪除操作， 
// 在成功操作後，會觸發 onSuccess 回調來刷新相關查詢（"actionList"）。
export const useDelectionAction = (stateCid: QueryKey) => {
  const queryClient = useQueryClient();

  return useMutation((param: any) => deleteActionById(param), {
    onSuccess: () => queryClient.invalidateQueries(["actionList", stateCid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const deleteRepositoryFileByName = (param: any) => {
  const { level, stateCid, loginCid, record } = param;
  let body: any = { delete_file: {} };

  if (record) {
    body.delete_file.cid = record.cid;
    body.delete_file.name = record.name;
    body.delete_file.type = record.type;
  }
  //delete all
  else {
    if (level === "super_super" && stateCid !== "") {
      body.delete_file.cid = stateCid;
    } else {
      body.delete_file.cid = loginCid;
    }
  }
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/repository",
    data: body,
  };
  return service(config);
};
// 自定義的 Hook，用於刪除設備升級儲存庫中的文件。根據參數（level、stateCid、loginCid、record）來刪除文件。
// 在成功操作後，會觸發 onSuccess 回調來刷新相關查詢（"repositoryList" 和 "reportList"）。
export const useRepositoryDeleteFile = (stateCid: string) => {
  const queryClient = useQueryClient();
  return useMutation((param: any) => deleteRepositoryFileByName(param), {
    onSuccess: () => {
      queryClient.invalidateQueries(["repositoryList", stateCid]);
      queryClient.invalidateQueries(["reportList", stateCid]);
    },
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const uploadRepositoryFile = (param: any) => {
  const { level, stateCid, loginCid, values } = param;
  const formData = new FormData();
  formData.append("file", values.upload.fileList[0].originFileObj);

  let cid;
  if (level === "super_super" && stateCid !== "") {
    cid = stateCid;
  } else if (level !== "super_super") {
    cid = loginCid;
  } else if (level === "super_super" && stateCid === "") {
    cid = "osmart";
  }

  const UploadUrl = `/repository?upload_file={"cid":"${cid}","name":"${
    values.filename || values.upload.file.name
  }","type":"${values.type}","inf": {"md5":"${values.md5}","model": "${values.model}"}}`;
  return service.post(UploadUrl, formData);
};
// 自訂義Hook 用於上傳文件到設備升級儲存庫。根據參數（level、stateCid、loginCid、values）來上傳文件。
// 在成功操作後，會觸發 onSuccess 回調來刷新相關查詢（"repositoryList"）。
export const useUploadRepository = (stateCid: string) => {
  const queryClient = useQueryClient();
  return useMutation((param: any) => uploadRepositoryFile(param), {
    onSuccess: () => queryClient.invalidateQueries(["repositoryList", stateCid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const renameFileByName = (param: any) => {
  const { record, values } = param;
  let body: any = {
    rename_file: {
      cid: record.cid,
      old_name: record.name,
      new_name: values.name,
      type: record.type,
    },
  };

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/repository",
    data: body,
  };
  return service(config);
};
// 自訂義 Hook ，用於根據參數（record、values）重命名設備升級儲存庫中的文件。
// 在成功操作後，會觸發 onSuccess 回調來刷新相關查詢（"repositoryList"）。
export const useRepositoryRenameFile = (stateCid: string) => {
  const queryClient = useQueryClient();
  return useMutation((param: any) => renameFileByName(param), {
    onSuccess: () => queryClient.invalidateQueries(["repositoryList", stateCid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const setDeviceAction = (param: any) => {
  const { level, stateCid, loginCid, time_zone, values } = param;

  const body = values.Device_ID.map((item: any) => {
    let data: any = { id: item, inf: { model: values.Model || values.model } };

    if (values.utc) {
      data.utc = values.utc.unix();
    }

    if (level === "super_super" && stateCid !== "") {
      data.cid = stateCid;
    } else if (level !== "super_super") {
      data.cid = loginCid;
    }
    //judge data type
    if (values.Action === "upgrade" || values.action === "upgrade") {
      data.type = "fw";
    } else if (values.Action === "restore" || values.action === "restore") {
      data.type = "cfg";
    } else if (values.Action === "backup" || values.action === "backup") {
      data.type = "cfg";
    }
    //judge file name
    if (values.Action === "backup" || values.action === "backup") {
      let date = TimestampToDate(Date.now(), time_zone);
      data.name = `${item}_${date.replace(":", "_")}.tgz`;
    } else {
      data.name = values.files || values.name || values.fileName;
    }
    return data;
  });

  const BRUBody: any = { set: {} };
  BRUBody.set[`${values.Action ?? values.action}`] = body;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: BRUBody,
  };

  return service(config);
};
// 自定義的 Hook，用於設定設備升級操作。根據參數（level、stateCid、loginCid、time_zone、values）來設定操作。
// 在成功操作後，會觸發 onSuccess 回調來刷新相關查詢（"actionList"）。

export const useUpdateDeviceAction = (stateCid: string) => {
  const queryClient = useQueryClient();
  return useMutation((param: any) => setDeviceAction(param), {
    onSuccess: () => queryClient.invalidateQueries(["actionList", stateCid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
